import { render, staticRenderFns } from "./PublicationHeader.vue?vue&type=template&id=45cb341c&scoped=true&lang=pug&"
import script from "./PublicationHeader.vue?vue&type=script&lang=js&"
export * from "./PublicationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb341c",
  null
  
)

export default component.exports